export default __webpack_public_path__ + "static/media/prudential-glyph.2d77d79c.png";